import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import classNames from "classnames";
import React from "react";

export type CardBodyComponentProps = {};

export type CardBodyProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, CardBodyComponentProps, "div">;

const CardBody = <T extends React.ElementType = "div">({
    ref,
    className,
    tag,
    ...attributes
}: CardBodyProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);
    const classes = classNames(className, "card-body");

    return (
        <Tag
            {...attributes}
            className={classes}
            ref={ref}
        />
    );
};

export { CardBody };
